import tw from "twin.macro";
export const LinkButton = tw.a`px-8 py-3 font-bold rounded bg-gray-700 text-gray-100 hocus:bg-gray-900 hocus:text-gray-200 focus:shadow-outline focus:outline-none transition duration-300`;
